module.exports = __webpack_public_path__ + "static/img/join_14.197ae3a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/join_14.png
// module id = WlCR
// module chunks = 0